import ApiGet from "api/ApiGet";
import { uAPI } from "api/config";
import ReactSlideshow from "components/reuseable/Slideshow/ReactSlideshow";
import SlideshowCustom from "components/reuseable/Slideshow/SlideshowCustom";
import React, { Fragment, useEffect, useState } from "react";
import Media from "react-media";
import { Link } from "react-router-dom";
import { responseResult } from "utils/ResponseStatus";

const AnakPerusahaanHome = (props) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        ApiGet.actions.AnakPerusahaan()
            .then((response) => {
                if (responseResult(response)) {
                    setData(responseResult(response))
                }
            })
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {
                data.length > 0 && (
                   
                    <div className="border py-[20px] rounded-lg">
                        <ReactSlideshow indicators={false} arrows={false} slidesToShow={6} slidesToScroll={1} responsive={[]}
                        >
                            {
                                data.map((_val, _index) => {
                                    // console.log(_val, "valuee")
                                    return (

                                        <div key={_index} className="flex flex-col mx-3 cursor-pointer" onClick={() => {
                                            if (_val?.company_website) {
                                                window.open(_val?.company_website ? _val?.company_website : "#", "_blank")
                                            }
                                        }} >
                                            <img style={{ width: '180px' }} className="flex flex-row justify-center" src={uAPI + _val.company_logo} alt={_val.company_logo_alt} />
                                        </div>

                                    )
                                })
                            }
                        </ReactSlideshow>
                    </div>
                )
            }
        </>
    )
}
export default AnakPerusahaanHome;